module.exports = __webpack_public_path__ + "img/default_logo.1ae9024b.png";